<div *ngIf="loading" class="loader-overlay">
        <div class="loader"></div>
    </div>
     <div class="container-fluid px-4">

        <div class="card mt-4">

            <div class="card-header">
  
          
                <h1 class=""style="font-size:22px" >レントゲン一覧</h1>
                 <div class="d-flex justify-content-between align-items-center mb-3">
                    <!-- Left: Items per page -->
                    <div class="d-flex align-items-center">
                        <label class="mr-2 mb-0" style="margin-right: 5px;">表示件数</label>
                        <select class="custom-select w-auto" style="margin-left: 5px;" (change)="onLimitChange($event)">
                            <option [selected]="limit === 10" value="10">10</option>
                            <option [selected]="limit === 25" value="25">25</option>
                            <option [selected]="limit === 50" value="50">50</option>
                            <option [selected]="limit === 100" value="100">100</option>
                        </select>
                        <span class="ml-1" style="margin: 10px;">件</span>
                        <!-- <select class="custom-select w-auto">
                            <option value="ステータス">ステータス</option>
                            <option value="ステータス">ステータス</option>
                            <option value="ステータス">ステータス</option>
                        </select> -->
                    </div>

                    <!-- Right: Search box with icon inside -->
                    <div class="position-relative" style="width: 250px;">
                        <i class="fas fa-search search-icon"></i>
                        <input type="text" class="form-control pl-5" placeholder="顧客名、対象者で検索" 
                        [(ngModel)]="searchField" maxlength="35" (keyup.enter)="onSearchFieldChange()"/>
                    </div>
                </div>

                <div class="table-responsive text-nowrap">
                    <table id="completedOrderDataTable" class="table" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>{{japaneseLabel['applicationNumber']}} </th>
                                <th>{{japaneseLabel['applicationDateTime']}} </th>
                                <th>{{japaneseLabel['customerNames']}} </th>
                                <th>{{japaneseLabel['status']}}</th>                         
                                <th>{{japaneseLabel['desiredNumber']}}</th>
                                <th>{{japaneseLabel['conversionStatus']}}</th>
                                <th>{{japaneseLabel['action']}}</th>                              
                               

                            </tr>
                        </thead>
                        <tbody class="table-border-bottom-0">

                            <tr *ngFor="let order of orderList;"  >
                                <td>
                                    <a class="route" [routerLink]="['/dashboard/x-ray-detail']"[queryParams]="{ order_id: order.order_record_id}">
                                        {{order.serial_no}} 
                                    </a>
                                </td>
                                <td>
                                    <a class="route" [routerLink]="['/dashboard/x-ray-detail']" [queryParams]="{ order_id: order.order_record_id}">
                                        {{order.created_at ?( order.created_at | keepTimezone:'yyyy-MM-dd HH:mm'):'無し'}}
                                    </a>
                                </td>
                                <td>
                                    <a class="route" [routerLink]="['/dashboard/x-ray-detail']" [queryParams]="{ order_id: order.order_record_id}">
                                        {{order.customer_name}} ({{order.controll_no}})
                                    </a> 
                                </td>                    
                                <td>
                                    <a class="route" [routerLink]="['/dashboard/x-ray-detail']" [queryParams]="{ order_id: order.order_record_id}">
                                       {{order.order_status}}
                                    </a> 
                                </td>
                               
                                <td>
                                    <a class="route" [routerLink]="['/dashboard/x-ray-detail']" [queryParams]="{ order_id: order.order_record_id}">
                                    {{order.files_count}} 枚
                                    </a> 
                                </td>
                                <td>
                                    <a class="route" [routerLink]="['/dashboard/x-ray-detail']" [queryParams]="{ order_id: order.order_record_id}">
                                       {{
                                            order.failed_files != 0
                                                ? '失敗した'
                                                : (order.files_count == order.completed_files ? '完了' : '処理中')
                                        }}
                                    </a>
                                    
                                </td>                               
                                 <td>
                                    <div *ngIf="order.order_status==='deleted'">
                                       
                                        <select class="btn"
                                        [ngClass]="'btn-outline-danger'"
                                        (change)="updateStatus(order, $event)"
                                        [disabled]="order.order_status=='deleted'">
                                            <option [value]="order.order_status" selected>
                                            削除済み
                                            </option>
                                            <option value="toggle" *ngIf="!order.is_valid">有効にする</option>
                                            <option value="toggle" *ngIf="order.is_valid">無効にする</option>  
                                                                                                                  
                                        </select> 
                                           
                                    </div>
                                    <div *ngIf="order.order_status!=='deleted'">                                       
                                        <select class="btn"
                                            [ngClass]="order.is_valid ? 'btn-outline-success' : 'btn-outline-danger'"
                                            (change)="updateStatus(order, $event)"
                                            [disabled]="order.files_count != order.completed_files || order.failed_files !=0">
                                            <option [value]="order.is_valid" selected>
                                            {{ order.is_valid ? '有効' : '無効' }}
                                            </option>
                                            <option value="toggle" *ngIf="!order.is_valid">有効にする</option>
                                            <option value="toggle" *ngIf="order.is_valid">無効にする</option>
                                        </select>
                                    </div>
                                </td>

                 
                            </tr>                                                
                           
                 
                        </tbody>

                    </table>
                </div>
                 <ul class="pagination justify-content-center" *ngIf="totalCount">
                  
                    <!-- Page Numbers -->
                    <li *ngFor="let page of pages" class="page-item" [class.active]="page === currentPage">
                        <a class="page-link" href="javascript:void(0)" (click)="goToPage(page)">
                        {{ page }}
                        </a>
                    </li>

                    <!-- Next -->
                    <li class="page-item" [class.disabled]="currentPage === totalPages">
                        <a class="page-link" href="javascript:void(0)" (click)="nextPage()">
                        <i class="fas fa-angle-right"></i>
                        </a>
                    </li>
                </ul>
                <div class="d-flex justify-content-center" *ngIf="totalCount">
                    {{startIndex}}〜{{endIndex}}件 / {{totalCount}}
                </div>
            </div>
        </div>

    </div>